import { AfterViewInit, Directive, ElementRef, input } from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';

@Directive({
  standalone: false,
  selector: '[appSwiper]'
})
export class SwiperDirective implements AfterViewInit {
  readonly config = input<SwiperOptions|undefined>(undefined);

  constructor(private el: ElementRef<SwiperContainer>) { }

  ngAfterViewInit(): void {
    Object.assign(this.el.nativeElement, this.config());

    this.el.nativeElement.initialize();
  }
}